export default __webpack_public_path__ + "static/media/session-expired.195ddc11.svg";